module.exports = __webpack_public_path__ + "static/b3-fbecd7c4952f65f240c1a696bda9c9ab.jpg";